import { useEffect, useState } from 'react';
import { CgCalculator } from "react-icons/cg";
import { FaStar } from "react-icons/fa";
import { FaHouseLaptop } from 'react-icons/fa6';
import { GiClockwork } from 'react-icons/gi';
import { LiaSwatchbookSolid } from "react-icons/lia";
import { Link } from 'react-router-dom';
import BgImage from "../../assets/images/businessStratup.png";
import headerImg from "../../assets/images/headerImg.png";
import RegulatoryComplience from '../../assets/images/Regulatory_Complience.png';
import Faq from '../../components/Faq';
import HomeCard from '../../components/HomeCard';
import IndustryShowcase from '../../components/IndustryShowcase';
import LazyImg from '../../components/LazyImg';
import Meta from '../../components/Meta';
import RotatingCircle from '../../components/RotatingCircle/RotatingCircle';
import Testimonial from '../../components/Testimonial';
import Timeline from '../../components/Timeline';
import VATCalculator from '../../components/VATCalculator';

export default function HomePage() {
    const [entity, setEntity] = useState('');
    const [state, setState] = useState('');
    const [responsiveClass, setResponsiveClass] = useState(false);

    const handleEntityChange = (event) => setEntity(event.target.value);
    const handleStateChange = (event) => setState(event.target.value);

    const faqItems = [
        {
            title: 'How to incorporate/register a company in Bangladesh ?',
            content: <strong>Yes, Foreign investors can incorporate a fully owned company, subsidiary or have a jointly owned company in Bangladesh.</strong>
        },
        {
            title: 'Foreign Company Registration in Bangladesh ?',
            content: <strong>To set up a Bangladesh company, your first step would be to obtain a name clearance for the proposed company name. You will have to visit <a href="www.roc.gov.bd">www.roc.gov.bd</a></strong>
        },
        {
            title: 'Trademark Registration Process in Bangladesh ?',
            content: <p>Trademark Registration Process. <strong>Step 1: Searching for Trademark Registration . Step2: Power of Power of Attorney Step 3: Filling an Application for Trademark Registration, Next Up to Final Registration.</strong></p>
        }
    ];

    const bgStyle = {
        backgroundImage: `url(${BgImage})`,
        width: 'auto',
        backgroundPosition: "right top",
        backgroundRepeat: "no-repeat",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "282px"
    };

    useEffect(() => {
        const handleResize = () => {
            setResponsiveClass(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const getResponsiveFont = (base, small) => (responsiveClass ? small : base);

    return (
        <main style={{ maxWidth: "100%" }}>
            <Meta
                title={"JK Associates | Foreign Company Registration in Bangladesh | Taxation & Business Consulting"}
                description="Expert in foreign company registration, taxation, and business consulting in Bangladesh. Start and grow your business with JK Associates."
                image={RegulatoryComplience}
                keywords="Setup Foreign Company, Foreign Company Registration, Company Registration, Tax Lawyer, VAT Consultant, Trademark Registration, copyright Registration, VAT return submission, monthly VAT return submission, withholding Tax filling, foreign company FDI reporting, Certified VAT Consultant, VAT Calculator"
            />

            {/* header start  */}
            <section className='heroSection'>
                <div className='r-container'>
                    <div style={{ justifyContent: "space-between" }} className='row row-cols-lg-2 row-cols-1 align-items-center'>
                        <div className='d-flex flex-column gap-4 pe-lg-5 m-margin-top-1 z-0'>
                            <span style={{ color: "#4caf50", fontSize: getResponsiveFont("18px", "14px") }} className="font-2 m-text-center m-text-sm">
                                Welcome to JK Associates Group
                            </span>
                            <Link className='m-d-none' target='_blank' to="https://www.google.com/maps/place/JK+Associates+%7C+Income+Tax+%7C+VAT+%7C+Company+Registration+%7C+Copyright+%7C+Trademark/@23.7927683,90.3719291,17z/data=!4m16!1m9!3m8!1s0x3755b8bf5300eaad:0xe50b10a249f6394e!2sJK+Associates+%7C+Income+Tax+%7C+VAT+%7C+Company+Registration+%7C+Copyright+%7C+Trademark!8m2!3d23.7927683!4d90.374504!9m1!1b1!16s%2Fg%2F11c54h2yxw!3m5!1s0x3755b8bf5300eaad:0xe50b10a249f6394e!8m2!3d23.7927683!4d90.374504!16s%2Fg%2F11c54h2yxw?entry=ttu&g_ep=EgoyMDI1MDgzMC4wIKXMDSoASAFQAw%3D%3D">
                                <span className='home-top bg-secondary opacity-75 p-2' style={{ fontSize: getResponsiveFont("16px", "12px") }}>
                                    Excellent 5 out of 5&nbsp;
                                    <FaStar style={{ color: "yellow", marginBottom: "5px" }} /> Google
                                </span>
                            </Link>

                            <h1 style={{ marginBottom: "0", fontSize: getResponsiveFont("40px", "24px"), textAlign: "center" }}>
                                Make Your Business With Us
                            </h1>
                            <p style={{ textAlign: 'justify', fontSize: getResponsiveFont("16px", "12px") }}>
                                From anywhere in the world, our complete platform simplifies the Bangladesh company registration,
                                allowing you to establish your business​. JK Associates" company formation for non-Bangladesh residents.
                                Easily start a Bangladesh business, online.
                            </p>

                            <div className="d-flex align-items-center justify-content-center dropdown-11">
                                <label htmlFor="formFile" className="form-label me-5 mb-0" style={{ fontSize: getResponsiveFont("16px", "12px") }}>Entity</label>
                                <select className="form-select mb-0" aria-label="Default select example" value={entity} onChange={handleEntityChange}>
                                    <option value="">Select Entity</option>
                                    <option value="Limited / Ltd.">Limited / Ltd.</option>
                                    <option value="One Person Company (OPC)">One Person Company (OPC)</option>
                                    <option value="Society Registration">Society Registration</option>
                                    <option value="Partnership Firm Registration">Partnership Firm Registration</option>
                                </select>
                            </div>
                            <div className="mb-3 d-flex align-items-center justify-content-center dropdown-11">
                                <label htmlFor="formFile" className="form-label me-5 mb-0" style={{ fontSize: getResponsiveFont("16px", "12px") }}>Division</label>
                                <select className="form-select mb-0" aria-label="Default select example" value={state} onChange={handleStateChange}>
                                    <option value="">Select Division</option>
                                    <option value="Dhaka">Dhaka</option>
                                    <option value="Chittagong">Chittagong</option>
                                    <option value="Khulna">Khulna</option>
                                    <option value="Rajshahi">Rajshahi</option>
                                </select>
                            </div>
                            {(entity && state) && (
                                <button
                                    className='form-submit-button'
                                    style={{ fontSize: getResponsiveFont("16px", "12px") }}
                                    onClick={() => {
                                        // Redirect to ROC website
                                        window.location.href = "https://app1.roc.gov.bd/psp/nc_search?p_user_id=";

                                        // After 20 seconds, redirect back to JK Associates
                                        setTimeout(() => {
                                            window.location.href = "https://www.jkassociates.com.bd";
                                        }, 20000);
                                    }}
                                >
                                    Get Started
                                </button>
                            )}
                        </div>
                        {/* header right side img */}
                        <RotatingCircle />
                    </div>
                </div>
            </section>
            {/* header end  */}

            {/* about us start */}
            <section className='heroSection margin-top-xl m-margin-top-1'>
                <div className='r-container'>
                    <div style={{ justifyContent: "space-between" }} className='row row-cols-lg-2 row-cols-1 align-items-center'>
                        <div className='col col-lg-6 ps-0 d-none d-sm-block'>
                            <div className='mb-5 pb-5 px-5'>
                                <LazyImg img={{ src: headerImg, alt: "Bussiness Setup Bangladesh" }} className="heroImg" />
                            </div>
                        </div>
                        <div className='col col-lg-6 ps-0 mt-5'>
                            <div style={{ paddingBottom: "60px", borderBottom: "1px solid #484848" }} className='d-flex flex-column gap-4 pe-lg-5'>
                                <span style={{ color: "#4caf50", fontSize: getResponsiveFont("18px", "14px") }} className="font-2 m-text-center">About Us</span>
                                <h1 style={{ marginBottom: 0, fontSize: getResponsiveFont("36px", "20px") }} className="font-3 fw-bold m-text-lg m-text-center">
                                    Your Trusted Advisors in Business Success.
                                </h1>
                                <p style={{ textAlign: 'justify', fontSize: getResponsiveFont("16px", "12px") }}>
                                    <b>"JK Associates"</b> is top-ranked Corporate Consultancy and Law
                                    firm in Bangladesh with the international presence provides specialized services in Intellectual
                                    Property Rights, Corporate Affairs, Foreign Trade and Investment, Taxation, and Litigation.
                                </p>
                                <div className='m-margin-auto'>
                                    <Link to="/about-us">
                                        <button className='form-submit-button' style={{ fontSize: getResponsiveFont("16px", "12px") }}>More about JK Associates</button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* about us end */}

            {/* resource cards */}
            <section>
                <h1 style={{ textAlign: "center", marginTop: "40px", fontSize: getResponsiveFont("36px", "20px") }}>
                    The One-Stop Solution For Entrepreneurs
                </h1>
                <div className="resource-container" style={{ marginTop: "20px" }}>
                    <div className="resource-card-container" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "20px" }}>
                        {[
                            { icon: GiClockwork, title: "On-the-ground experts", text: "Unlike competitors, we have a fully-fledged tax team based in Bangladesh. Our experts are directly involved in a situation or are at the place of your interest. Get answers through the app’s live chat, via email, or phone for easy access to advice and in-person consultation." },
                            { icon: FaHouseLaptop, title: "Get service remotely", text: "Start a company registration in Bangladesh and open an Aspire business account from anywhere in the world. We assist you online and help you with local compliance." },
                            { icon: CgCalculator, title: "Tax right from day one", text: "We give you guidance on the best business structure, set up your accounting, and inform you on tax reliefs available to your business so that you're set up to pay tax efficiently from the get-go." },
                            { icon: LiaSwatchbookSolid, title: "Long-term Compliance support", text: "Regulatory compliance support helps organizations maintain integrity, protect their reputation, and avoid penalties. It includes ongoing attention to regulatory changes, employee training, policy updates, and risk management, beyond initial setup and annual audits." }
                        ].map((card, i) => (
                            <div key={i} className="resource-card" style={{ minHeight: "300px", padding: "20px", textAlign: "center", border: "1px solid #ddd", borderRadius: "12px" }}>
                                <card.icon style={{ fontSize: getResponsiveFont("90px", "50px"), color: "#4caf50", margin: "10px 0" }} />
                                <h3 style={{ marginBottom: "10px", fontSize: getResponsiveFont("20px", "16px") }}>{card.title}</h3>
                                <p style={{ fontSize: getResponsiveFont("14px", "12px"), textAlign: "justify" }}>{card.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <IndustryShowcase />
            <div className="container-xxl"><VATCalculator /></div>

            {/* Centered text */}
            <div className='container-xxl text-center'>
                <h1 style={{ fontSize: getResponsiveFont("36px", "20px") }}>Where Global Entrepreneurs Thrive</h1>
                <p style={{ fontSize: getResponsiveFont("16px", "12px"), textAlign: "center" }}>
                    We make launching your Bangladesh business easy, fast, and effective
                </p>
                <button
                    className='btn btn-primary fs-3'
                    style={{ width: "215px", fontSize: getResponsiveFont("16px", "12px") }}
                    onClick={() => {
                        window.location.href = "https://api.whatsapp.com/send/?phone=01511404971&text&type=phone_number&app_absent=0";
                        setTimeout(() => {
                            window.location.href = "https://www.jkassociates.com.bd";
                        }, 20000);
                    }}
                >
                    Get Started
                </button>
            </div>

            <div className="container-xxl"><HomeCard /></div>

            {
                responsiveClass ? (
                    <div className='m-d-block container-xxl text-center'>
                        <img src={BgImage} style={{ display: "block", margin: "auto" }} alt="" />
                        <h1 style={{ fontSize: getResponsiveFont("36px", "20px") }}>How to open Company in Bangladesh</h1>
                    </div>
                ) : (
                    <div style={{ marginTop: "60px", ...bgStyle }} className='container-xxl text-center'>
                        <h1 style={{ fontSize: getResponsiveFont("36px", "20px") }}>How to open Company in Bangladesh</h1>
                    </div>
                )
            }

            <div className="container-xxl"><Timeline /></div>
            <div className="container py-5 my-0">
                <h2 style={{ fontSize: getResponsiveFont("32px", "18px") }} className="color-text text-center mb-4">Frequently Asked Questions</h2>
                <Faq items={faqItems} />
            </div>
            <div className="r-container py-5 my-5">
                <Link style={{ display: "block", textAlign: "center", marginBottom: "20px" }} target='_blank' to="https://www.google.com/maps/place/JK+Associates+%7C+Income+Tax+%7C+VAT+%7C+Company+Registration+%7C+Copyright+%7C+Trademark/@23.7927683,90.3719291,17z/data=!4m16!1m9!3m8!1s0x3755b8bf5300eaad:0xe50b10a249f6394e!2sJK+Associates+%7C+Income+Tax+%7C+VAT+%7C+Company+Registration+%7C+Copyright+%7C+Trademark!8m2!3d23.7927683!4d90.374504!9m1!1b1!16s%2Fg%2F11c54h2yxw!3m5!1s0x3755b8bf5300eaad:0xe50b10a249f6394e!8m2!3d23.7927683!4d90.374504!16s%2Fg%2F11c54h2yxw?entry=ttu&g_ep=EgoyMDI1MDgzMC4wIKXMDSoASAFQAw%3D%3D ">
                    <span className='home-top bg-secondary opacity-75 p-2' style={{ fontSize: getResponsiveFont("16px", "12px") }}>
                        Excellent 5 out of 5&nbsp;
                        <FaStar style={{ color: "yellow", marginBottom: "5px" }} /> Google
                    </span>
                </Link>
                <h1 style={{ fontSize: getResponsiveFont("36px", "20px") }} className='text-center mb-4'>Customer Experiences With Us</h1>
                <Testimonial isResponsive={responsiveClass} />
            </div>
        </main>
    );
}
